import { TransactionStatus } from '../constants';

/** Human-readable payment channel (offline / online), single line. */
export const getPaymentChannelDescription = (
  payment_mode: string,
  payment_method: string | null | undefined
) => {
  const method = payment_method ?? '';
  if (payment_mode === 'manual') {
    if (method === '' || method === null) return 'Paid Offline';
    if (method === 'Cash') return 'Paid Offline via Cash';
    return `Paid Offline via ${method}`;
  }
  if (payment_mode === 'automatic') {
    if (method === 'mandate') return 'Paid via CoFee Autodebit';
    return 'Paid via Cofee';
  }
  return '';
};

export const getPaymentStatusDisplayText = (
  status: TransactionStatus,
  payment_mode: string,
  payment_method: string
) => {
  if (status === TransactionStatus.TO_SETTLE) return 'Processing';
  if (status === TransactionStatus.SETTLED) {
    return getPaymentChannelDescription(payment_mode, payment_method);
  }
  if (status === TransactionStatus.PROCCESSING) return 'Pending';
  return '';
};
